import { useCallback, useState } from 'react';

export function useForceUpdate() {
  const [, setCount] = useState(0);

  return useCallback(() => setCount((prev) => prev + 1), [setCount]);
}
